export enum LocalPackAggregationTypeEnum {
    day = 'day',
    week = 'week',
    month = 'month',
}
